import { render } from "./CardData.vue?vue&type=template&id=51543818&scoped=true"
import script from "./CardData.vue?vue&type=script&lang=js"
export * from "./CardData.vue?vue&type=script&lang=js"

import "./CardData.vue?vue&type=style&index=0&id=51543818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51543818"]])

export default __exports__